import { render } from "./BankAccountTypeCreate.vue?vue&type=template&id=7a0d37b6"
import script from "./BankAccountTypeCreate.vue?vue&type=script&lang=js"
export * from "./BankAccountTypeCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__